import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ExportTypes } from '@shared/constants/constants';

@Pipe({
    name: 'exportType'
})
export class ExportTypePipe implements PipeTransform {
    constructor(
        private translation: TranslateService
    ) { }
    transform(value: number): string {
        let result = '';
        const exportType = ExportTypes(this.translation);
        if (exportType){
            const selected = exportType.find(x => x.id === value);
            if (selected){
                result = selected.text;
            }
        }

        return result;
    }
}
